import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { logoutSuccess } from '../../redux/reducers/Auth';
import { postLogout } from '../../services/Api';
import { decodeToken } from '../../utils';
import {
    MENU_CUSTOMER_SERVICE_CENTER,
    MENU_DENTAL_PLUS,
    MENU_RECRUIT,
    MENU_RESUME,
    MENU_SIDENAV_DENTAL,
    MENU_SIDENAV_USER,
} from '../constants/app';
const Header = () => {
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const token = login.token;
    const dispatch = useDispatch();
    const [infoToken, setInfoToken] = useState({});
    const [activeChild, setActiveChild] = useState(null);
    const [isMenuVisible, setMenuVisible] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const [keyword, setKeyword] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (loggedIn) {
            setInfoToken(decodeToken(token));
        }
    }, [loggedIn, token]);
    const handleOnChangeInput = (e) => {
        setKeyword(e.target.value);
    };

    const handleOnSubmit = (e) => {
        e.preventDefault();
        if (!keyword.trim()) {
            window.alert('검색어를 입력해 주세요');
            return;
        }
        navigate(`/pabaa010?keyword=${keyword}`);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleOnSubmit(e);
        }
    };

    // Toggle sidebar menu visibility
    const toggleMenu = () => {
        setMenuVisible(!isMenuVisible);
        setActiveSubmenu(null);
    };

    // Toggle submenu visibility
    const toggleSubmenu = (index) => {
        setActiveSubmenu(activeSubmenu === index ? null : index);
    };

    const handleChildClick = (index, parent, indexMenu) => {
        setActiveChild({ index, parent }); // Cập nhật li active
        localStorage.setItem('activeColorMenu', indexMenu);
    };
    // const handleLogout = () => {
    //     postLogout()
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 localStorage.removeItem('activeColorMenu');
    //                 localStorage.removeItem('lastVisitedUrl');
    //                 localStorage.removeItem('activePopUpMenu');
    //                 sessionStorage.removeItem('authPassVerified');
    //                 localStorage.removeItem('savedPAEAA010Conditions');
    //                 localStorage.removeItem('savedPAFAA010Conditions');
    //                 dispatch(logoutSuccess());
    //                 window.location.reload();
    //             }
    //         })
    //         .catch((error) => console.log(error));

    //     navigate('/');
    // };

    const handleLogout = async () => {
        try {
            await postLogout();
        } catch (error) {
            console.error('Logout API failed:', error);
        } finally {
            localStorage.removeItem('token');
            sessionStorage.clear();
            dispatch(logoutSuccess());
            window.location.href = '/';
        }
    };

    const activeColorMenu = localStorage.getItem('activeColorMenu');
    const location = useLocation();
    const isHome = location.pathname === "/";
    return (
        <div id="header">
            <div className="container">
                <div className="header-wrap">
                    <div className="header-left">
                        <Link
                            to="/"
                            style={{ width: 'max-content' }}
                            onClick={(e) => {
                                e.preventDefault();
                                localStorage.removeItem('activeColorMenu');
                                if (window.location.pathname === '/') {
                                    window.location.reload();
                                } else {
                                    window.location.href = '/';
                                }
                            }}
                        >
                            <img className="logo" src="./images/logo.png" alt="DentalJob Logo" />
                        </Link>
                        <div className="search-wrap">
                            <input
                                type="text"
                                placeholder="#대한민국 치과계 No.1 덴탈잡"
                                value={keyword}
                                autoComplete="newSearch"
                                name="search"
                                onChange={handleOnChangeInput}
                                onKeyDown={handleKeyDown}
                            />
                            <Link onClick={handleOnSubmit}>
                                <i className="icon icon-find" />
                            </Link>
                        </div>
                    </div>
                    <div className="header-right">
                        <img src="./images/intro-logo.png" alt="intro-logo" />
                    </div>
                    <div className="nav-wrap">
                        {!isHome && (
                            <img
                                className="icon-back"
                                src="./images/back.png"
                                alt="go back"
                                onClick={() => navigate(-1)}
                            />
                        )}
                        {loggedIn ? (
                            <Link to={infoToken?.authorities === 'ROLE_P' ? '/paiaf010' : '/pajah010'} className="nav-bell">
                                <i className="icon icon-bell" />
                            </Link>
                        ) : (
                            ''
                        )}

                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu();
                            }}
                        >
                            <i className={`icon icon-hamburger-bar ${isMenuVisible ? 'close active' : ''}`} />
                        </Link>
                    </div>

                    {/* Full screen overlay */}
                    <div
                        className={`full-screen-overlay ${isMenuVisible ? 'overlay-block' : ''}`}
                        onClick={toggleMenu}
                    />

                    {/* Sidebar Menu */}
                    <div className={`side-nav-res ${isMenuVisible ? 'showMenu' : ''}`}>
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu();
                            }}
                        >
                            <i className="icon icon-hamburger-bar close" />
                        </Link>
                        <ul className="frame-section">
                            {!loggedIn ? (
                                <div className="wrap-loggedIn-res loggedIn" onClick={toggleMenu}>
                                    <Link className="loggedIn-res" to="/login">
                                        로그인
                                    </Link>
                                    <Link className="loggedIn-res" to="/padaa010">
                                        회원가입
                                    </Link>
                                </div>
                            ) : (
                                ''
                            )}
                            <li
                                className={`menu-nav-child ${activeSubmenu === 0 ? 'active' : ''} ${activeColorMenu === '0' ? 'colorActive' : ''
                                    }`}
                            >
                                <ul className="sub-title-menu" onClick={() => toggleSubmenu(0)}>
                                    <li>
                                        <Link>채용정보</Link>
                                    </li>
                                    <li>
                                        <i className="icon icon-down" />
                                    </li>
                                </ul>
                                <ul className={`submenu ${activeSubmenu === 0 ? 'active' : ''}`}>
                                    {MENU_RECRUIT.map((item, index) => (
                                        <li
                                            key={'total_recruit_' + index}
                                            className={
                                                activeChild &&
                                                    activeChild.parent === 'total_recruit_' &&
                                                    activeChild.index === index
                                                    ? 'active'
                                                    : ''
                                            }
                                            onClick={() => handleChildClick(index, 'total_recruit_', 0)}
                                        >
                                            <Link to={item.url} onClick={toggleMenu}>
                                                {item.context}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li
                                className={`menu-nav-child ${activeSubmenu === 1 ? 'active' : ''} ${activeColorMenu === '1' ? 'colorActive' : ''
                                    }`}
                            >
                                <ul className="sub-title-menu" onClick={() => toggleSubmenu(1)}>
                                    <li>
                                        <Link>인재정보</Link>
                                    </li>
                                    <li>
                                        <i className="icon icon-down" />
                                    </li>
                                </ul>
                                <ul className={`submenu ${activeSubmenu === 1 ? 'active' : ''}`}>
                                    {MENU_RESUME.map((item, index) => (
                                        <li
                                            key={'total_resume_' + index}
                                            className={
                                                activeChild &&
                                                    activeChild.parent === 'total_resume_' &&
                                                    activeChild.index === index
                                                    ? 'active'
                                                    : ''
                                            }
                                            onClick={() => handleChildClick(index, 'total_resume_', 1)}
                                        >
                                            <Link to={item.url} onClick={toggleMenu}>
                                                {item.context}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li
                                className={`menu-nav-child ${activeSubmenu === 2 ? 'active' : ''} ${activeColorMenu === '2' ? 'colorActive' : ''
                                    }`}
                            >
                                <ul className="sub-title-menu" onClick={() => toggleSubmenu(2)}>
                                    <li>
                                        <Link>덴탈플러스</Link>
                                    </li>
                                    <li>
                                        <i className="icon icon-down" />
                                    </li>
                                </ul>
                                <ul className={`submenu ${activeSubmenu === 2 ? 'active' : ''}`}>
                                    {MENU_DENTAL_PLUS.map((item, index) => (
                                        <li
                                            key={'total_dental_plus_' + index}
                                            className={
                                                activeChild &&
                                                    activeChild.parent === 'total_dental_plus_' &&
                                                    activeChild.index === index
                                                    ? 'active'
                                                    : ''
                                            }
                                            onClick={() => handleChildClick(index, 'total_dental_plus_', 2)}
                                        >
                                            <Link to={item.url} onClick={toggleMenu}>
                                                {item.context}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li
                                className={`menu-nav-child ${activeSubmenu === 3 ? 'active' : ''} ${activeColorMenu === '3' ? 'colorActive' : ''
                                    }`}
                            >
                                <ul className="sub-title-menu" onClick={() => toggleSubmenu(3)}>
                                    <li>
                                        <Link>고객센터</Link>
                                    </li>
                                    <li>
                                        <i className="icon icon-down" />
                                    </li>
                                </ul>
                                <ul className={`submenu ${activeSubmenu === 3 ? 'active' : ''}`}>
                                    {MENU_CUSTOMER_SERVICE_CENTER.map((item, index) => (
                                        <li
                                            key={'customer_service_center_' + index}
                                            className={
                                                activeChild &&
                                                    activeChild.parent === 'customer_service_center_' &&
                                                    activeChild.index === index
                                                    ? 'active'
                                                    : ''
                                            }
                                            onClick={() => handleChildClick(index, 'customer_service_center_', 3)}
                                        >
                                            <Link to={item.url} onClick={toggleMenu}>
                                                {item.context}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            {loggedIn && infoToken.authorities === 'ROLE_P' && (
                                <li
                                    className={`menu-nav-child ${activeSubmenu === 4 ? 'active' : ''} ${activeColorMenu === '4' ? 'colorActive' : ''
                                        }`}
                                >
                                    <ul className="sub-title-menu" onClick={() => toggleSubmenu(4)}>
                                        <li>
                                            <Link>마이 페이지</Link>
                                        </li>
                                        <li>
                                            <i className="icon icon-down" />
                                        </li>
                                    </ul>
                                    <ul className={`submenu ${activeSubmenu === 4 ? 'active' : ''}`}>
                                        {MENU_SIDENAV_USER.flatMap((item, index) =>
                                            item.child ? (
                                                <li
                                                    key={'mypage_p_menu_' + index}
                                                    className={
                                                        activeChild &&
                                                            activeChild.parent === 'mypage_p_menu_' &&
                                                            activeChild.index === index
                                                            ? 'active'
                                                            : ''
                                                    }
                                                    onClick={() => handleChildClick(index, 'mypage_p_menu_', 4)}
                                                >
                                                    <NavLink to={item.urlCommon} onClick={toggleMenu}>
                                                        {item.context}
                                                    </NavLink>
                                                </li>
                                            ) : (
                                                <li
                                                    key={'mypage_p_menu_' + index}
                                                    className={
                                                        activeChild &&
                                                            activeChild.parent === 'mypage_p_menu_' &&
                                                            activeChild.index === index
                                                            ? 'active'
                                                            : ''
                                                    }
                                                    onClick={() => handleChildClick(index, 'mypage_p_menu_', 4)}
                                                >
                                                    <NavLink to={item.url} onClick={toggleMenu}>
                                                        {item.context}
                                                    </NavLink>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </li>
                            )}
                            {loggedIn && infoToken.authorities === 'ROLE_C' && (
                                <li
                                    className={`menu-nav-child ${activeSubmenu === 4 ? 'active' : ''} ${activeColorMenu === '4' ? 'colorActive' : ''
                                        }`}
                                >
                                    <ul className="sub-title-menu" onClick={() => toggleSubmenu(4)}>
                                        <li>
                                            <Link>마이 페이지</Link>
                                        </li>
                                        <li>
                                            <i className="icon icon-down" />
                                        </li>
                                    </ul>
                                    <ul className={`submenu ${activeSubmenu === 4 ? 'active' : ''} `}>
                                        {MENU_SIDENAV_DENTAL.flatMap((item, index) =>
                                            item.child ? (
                                                <li
                                                    key={'mypage_c_menu_' + index}
                                                    className={
                                                        activeChild &&
                                                            activeChild.parent === 'mypage_c_menu_' &&
                                                            activeChild.index === index
                                                            ? 'active'
                                                            : ''
                                                    }
                                                    onClick={() => handleChildClick(index, 'mypage_c_menu_', 4)}
                                                >
                                                    <NavLink to={item.urlCommon} onClick={toggleMenu}>
                                                        {item.context}
                                                    </NavLink>
                                                </li>
                                            ) : (
                                                <li
                                                    key={'mypage_c_menu_' + index}
                                                    className={
                                                        activeChild &&
                                                            activeChild.parent === 'mypage_c_menu_' &&
                                                            activeChild.index === index
                                                            ? 'active'
                                                            : ''
                                                    }
                                                    onClick={() => handleChildClick(index, 'mypage_c_menu_', 4)}
                                                >
                                                    <NavLink to={item.url} onClick={toggleMenu}>
                                                        {item.context}
                                                    </NavLink>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </li>
                            )}
                            {loggedIn && (
                                <li className="menu-nav-child loggedIn" style={{ height: '60px', padding: '0 25px' }}>
                                    <Link onClick={handleLogout}>로그아웃</Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
